import { ETH } from '../constants/assets'
import type { ChainConfig } from '../types'
import { getQuickNodeRpcUrl } from '../utils/getQuickNodeRpcUrl'

export const LINEA = {
  name: 'linea',
  chainId: 59144,
  averageBlockTimeSeconds: 2,
  explorerUrl: 'https://lineascan.build//',
  nativeAsset: ETH,
  slip44: 60,
  wrappedNativeAsset: '0xe5d7c2a44ffddf6b295a15c148167daaaf5cf34f',
  blockscoutApiUrl: 'https://explorer.linea.build/api',
  etherscanSupported: true,
  publicRpcUrls: ['https://rpc.linea.build', 'https://1rpc.io/linea'],
  getPrivateRpcUrls: () => {
    const linea: string[] = []
    process.env.ROUTEME_API_KEY && linea.push(`https://lb.routeme.sh/rpc/59144/${process.env.ROUTEME_API_KEY}`)
    const quickNodeUrl = getQuickNodeRpcUrl('linea')
    quickNodeUrl && linea.push(quickNodeUrl)
    return linea
  },
} as const satisfies ChainConfig
